import { render } from "./MentionSuggestionRichText.vue?vue&type=template&id=5d9d0997&scoped=true"
import script from "./MentionSuggestionRichText.vue?vue&type=script&lang=js"
export * from "./MentionSuggestionRichText.vue?vue&type=script&lang=js"

import "./MentionSuggestionRichText.vue?vue&type=style&index=0&id=5d9d0997&lang=scss"
import "./MentionSuggestionRichText.vue?vue&type=style&index=1&id=5d9d0997&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9d0997"]])

export default __exports__